import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GlobalStore } from '../../store';
import User from '../../models/User';
import { HTTP_SERVER_URL } from '../../configuration';

interface Booking {
  id: number;
  realname: string;
  slot_time: string;
  help: boolean;
}

function getToken(): string {
  const raw = localStorage.getItem('Token');
  return raw ? JSON.parse(raw).token : '';
}

function formatTime(iso: string): string {
  const d = new Date(iso);
  return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
}

const pastStyle: React.CSSProperties = { color: '#999' };

interface Props {
  queueName: string;
  refreshSignal?: number;
}

export default ({ queueName, refreshSignal }: Props): JSX.Element | null => {
  const user = useSelector<GlobalStore, User | null>(store => store.user);
  const [upcoming, setUpcoming] = useState<Booking[]>([]);
  const [past, setPast] = useState<Booking[]>([]);

  const isTA = user !== null && (user.isTeacherIn(queueName) || user.isAssistantIn(queueName));

  const fetchBookings = () => {
    fetch(`${HTTP_SERVER_URL}/api/queues/${queueName}/bookings`, {
      headers: { Authorization: `Token ${getToken()}` }
    })
      .then(r => r.json())
      .then((data: Booking[]) => {
        const now = new Date();
        const today = now.toDateString();
        const todayBookings = data
          .filter(b => new Date(b.slot_time).toDateString() === today)
          .sort((a, b) => a.slot_time.localeCompare(b.slot_time));
        setUpcoming(todayBookings.filter(b => new Date(b.slot_time) >= now));
        setPast(todayBookings.filter(b => new Date(b.slot_time) < now));
      })
      .catch(() => { setUpcoming([]); setPast([]); });
  };

  useEffect(() => {
    if (!isTA) return;
    fetchBookings();
    const id = setInterval(fetchBookings, 60_000);
    return () => clearInterval(id);
  }, [queueName, isTA]);

  useEffect(() => {
    if (!isTA || refreshSignal === undefined) return;
    fetchBookings();
  }, [refreshSignal]);

  if (!isTA) return null;
  if (upcoming.length === 0 && past.length === 0) return null;

  return (
    <details className="col-12 mt-3 p-0">
      <summary className="clickable" style={{ listStyle: 'none', display: 'block', padding: '8px 12px', fontWeight: 600, borderRadius: '4px', background: '#f0f0f0', border: '1px solid #ccc', marginBottom: '4px' }}>
        Today's bookings ({upcoming.length + past.length})
      </summary>
      <div className="mt-1">
        <table className="table table-sm mb-0" style={{ fontSize: '0.9em' }}>
          <tbody>
            {upcoming.map(b => (
              <tr key={b.id}>
                <td style={{ width: '3.5em' }}>{formatTime(b.slot_time)}</td>
                <td>{b.realname}</td>
              </tr>
            ))}
            {past.map(b => (
              <tr key={b.id} style={pastStyle}>
                <td style={{ width: '3.5em' }}>{formatTime(b.slot_time)}</td>
                <td>{b.realname}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
};
